import { store as RRRStore } from 'redux-rest-reducer';

import { useAppSelector } from '@~/hooks';
import { type HomeDetailsData } from '@~/type-props/home-details';

const useStudentHomeDetails = (): HomeDetailsData => {
  const userId = useAppSelector(({ auth }) => auth.userId);
  const homeDetails = useAppSelector(store => store.homeDetails);

  const studentHomeData = RRRStore.get(homeDetails, userId)?.data || {};

  return studentHomeData;
};

export default useStudentHomeDetails;
